// extracted by mini-css-extract-plugin
export var awarnessContent = "AwernessSection-module--awarnessContent--2f557";
export var backgroundClassName = "AwernessSection-module--backgroundClassName--07129";
export var headingContainerStyling = "AwernessSection-module--headingContainerStyling--da2aa";
export var headingStyling = "AwernessSection-module--headingStyling--92509";
export var ratingContainer = "AwernessSection-module--ratingContainer--ee45d";
export var ratingContent = "AwernessSection-module--ratingContent--fdddd";
export var ratingsTitle = "AwernessSection-module--ratingsTitle--db591";
export var ratingsTitles = "AwernessSection-module--ratingsTitles--50681";